import Axios from '.'
import { AxiosConfigType } from '../types'
import { CertificateType } from '../types/api/certificates'
import { OptionalParamsApi, PaginationResponseSecondFormat } from '../types/api'
import { generateParamsURL } from '../utils'


const normalizeCertificatesResponse = (
  response: PaginationResponseSecondFormat<CertificateType> & {
    data?: CertificateType[] | Record<string, CertificateType>
  },
): PaginationResponseSecondFormat<CertificateType> => ({
  ...response,
  data: Array.isArray(response.data) ? response.data : Object.values(response.data ?? {}),
})

const getCertificates = async (
  params: OptionalParamsApi,
  config?: AxiosConfigType,
) => {
  const response = await Axios.get<PaginationResponseSecondFormat<CertificateType>>(
    `certificates?${generateParamsURL(params)}`,
    config,
  )
  return normalizeCertificatesResponse(response.data)
}

const CertificatesApi = {
    getCertificates,
}

export default CertificatesApi